import { Injectable } from '@angular/core';
import { WebIntent } from "@ionic-native/web-intent";
import * as xml2js from 'xml2js';
import {InAppBrowser} from "@ionic-native/in-app-browser";

@Injectable()

export class MruService {

  callback = null;

  constructor(
    public webIntent: WebIntent,
    public iab: InAppBrowser
  ) {}

  startMeasurement(fuel, measurement_type, ios?){
    return new Promise((resolve, reject) => {
      let now = new Date();
      let date = now.getFullYear() + '-' + (now.getMonth() >= 9 ? ('' + now.getMonth()+1) : ('0' + (now.getMonth()+1))) + '-' + (now.getDate() > 9 ? now.getDate() : '0' + now.getDate());
      let xml = '42<?xml version="1.0" encoding="utf-8"?><SingleStart xmlns="urn:ZIV-schema" TransmissionId="' + date + '"><Version>1.00</Version><FuelId>' + fuel + '</FuelId><RequiredMeasurements>' + measurement_type + '</RequiredMeasurements></SingleStart>';
      let url = 'mru4urequest://mru/';
      url += encodeURIComponent(xml);
      if (ios) {
        // IOS
        this.iab.create(url, '_system');
        resolve();
      } else {
        // Android
        let options = {
          action: this.webIntent.ACTION_VIEW,
          requestCode: 1543,
          url: url
        };
        this.webIntent.startActivityForResult(options).then((intent) => {
          console.log('MRU measurement success');
          let data: string = intent.data;
          console.log(data);
          if (data.substr(0, 2) == '42') {
            data = data.substr(2);
          }
          this.extractData(data).then((result) => {
            resolve(result);
          }).catch((err) => {
            reject(-2);
          })
        }, (err) => {
          console.log('MRU measurement error');
          console.log(JSON.stringify(err));
          reject(-1);
        });
      }
    });
  }

  setResponseCallback(func) {
    this.callback = func;
  }

  triggerResponseCallback(url) {
    if (url.substr(0, 3) == '/42') {
      url = url.substr(3);
    } else if (url.substr(0, 2) == '42') {
      url = url.substr(2);
    } else {
      return;
    }
    this.extractData(url).then((data) => {
      this.callback(data);
    }).catch(() => {
      //
    });
  }

  extractData(xml:string){
    let mapping = [
      ['co_ppm', 'CO_DIL_EXH', 'UNIT_PPM'], // CO_Norm UNIT_PPM
      ['co2_percent', 'CO2', 'UNIT_VOL_PERCENT'], // CO2 UNIT_VOL_PERCENT
      ['o2_percent', 'O2', 'UNIT_VOL_PERCENT'], // O2 UNIT_VOL_PERCENT
      ['t_flue_deg_c', 'T_FLUE', 'UNIT_DEG_C'], // T_Flue UNIT_DEG_C
      ['t_air_deg_c', 'T_AIR', 'UNIT_DEG_C'], // T_Air UNIT_DEG_C
      ['p_chimney_mbar', 'P_DRAFT', 'UNIT_MBAR'], // P_Draft UNIT_MBAR
      ['efficiency_hi_percent', 'EFFICIENCY', 'UNIT_PERCENT'], // Efficiency UNIT_PERCENT
      ['lambda', 'LAMBDA', 'UNIT_VOL_PERCENT'], // Lambda UNIT_VOL_PERCENT
    ];
    return new Promise((resolve, reject) => {
      if(xml){
        const parser = new xml2js.Parser({
          strict: false,
          trim: true
        });
        parser.parseString(xml, (err, data:any) => {
          console.log(data);
          let output = {};
          if(data.SINGLERESULT){
            data = data.SINGLERESULT;
            // Instrument
            if(data.INSTRUMENT){
              if(data.INSTRUMENT.length > 0){
                // device_sn
                if(data.INSTRUMENT[0].SERIALNUMBER.length > 0){
                  output['device_sn'] = data.INSTRUMENT[0].SERIALNUMBER[0];
                }
              }
            }

            // Fireplace
            if(data.FIREPLACE.length > 0){
              // OILGASMEASUREMENT
              if(data.FIREPLACE[0].OILGASMEASUREMENT.length > 0){
                let measurements = data.FIREPLACE[0].OILGASMEASUREMENT[0];
                for(let i = 0; i < mapping.length; i++){
                  let form_field = mapping[i][0];
                  let xml_field = mapping[i][1];
                  let unit = mapping[i][2];
                  if(measurements[xml_field] && measurements[xml_field].length > 0){
                    let field = measurements[xml_field][0];
                    if(!field['$']['ERROR'] && field['$']['UNIT'] == unit){
                      output[form_field] = field['_'];
                    }
                  }
                }
              }
            }
          }
          console.log(output);
          resolve(output);
        });
      } else {
        reject();
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/services/mru.service.ts